import * as ThemeCategories from "../constants/theme-categories";

export default {
    computed: {
        selectedThemeCategory() {
            if (!this.$store.state.current_community) {
                // corwin employee editing the calendar
                return null;
            }
            return this.$store.state.current_community.has_logo &&
                !this.$store.state.current_community.no_calendar_logo &&
                !this.calendar.remove_logo
                ? ThemeCategories.WITH_LOGO
                : ThemeCategories.NO_LOGO;
        },
    },
};
